module.exports = __webpack_public_path__ + "img/cuota.8e86310c.jpg";